import { lang, commonLang } from '@umu/ukit-lang';
/**
 * @description
 */

import './sectionResultItemHeader.scss';

import React, { Component } from 'react';
import * as ImageUtil from '@umu/umu-image-handle';
import { ISurveySectionInfo, ESurveySectionType } from '@umu/umu-types';
import { components } from 'common';
const { PreImg, showFullImgGallery } = components;

export interface IProps {
    sectionInfo: ISurveySectionInfo;
}

export default class SectionResultItemHeader extends Component<IProps> {
    constructor(props: IProps) {
        super(props);
    }

    public renderSectionHeader() {
        const { sectionIndex, title } = this.props.sectionInfo;

        return (
            <div className={`section-result-item-header`}>
                <div className={`section-result-item-header-title`}>
                    {sectionIndex ? <span className={`section-num`}>Q{sectionIndex}. </span> : null}
                    <div className="item-content">
                        <span className="section-title">{title}</span>
                        <span className="section-title-desc">{this.getTitleRange()}</span>
                    </div>
                </div>
                {this.renderSectionHeaderImage()}
            </div>
        );
    }

    public renderSectionHeaderImage() {
        const { resource_arr = [] } = this.props.sectionInfo.extend;
        const resourceInfo = resource_arr[0];
        if (!resourceInfo) {
            return null;
        }

        const url = resourceInfo.resource_data.url;
        const thumbUrl = ImageUtil.appendWidth(url);
        const resourceData = Object.assign({}, resourceInfo.resource_data, {
            thumb_url: thumbUrl,
        });

        return (
            <div className="section-header-img">
                <div className="img">
                    <PreImg>
                        <img
                            src={thumbUrl}
                            alt=""
                            onClick={() => {
                                showFullImgGallery({
                                    index: 0,
                                    imgList: [resourceData],
                                });
                            }}
                        />
                    </PreImg>
                </div>
            </div>
        );
    }

    public getTitleRange = () => {
        const { sectionInfo } = this.props;
        const { type, list, extend, userCount } = sectionInfo;
        const { setup } = extend;

        const retTitle = [];
        let ret = '';

        if (type === ESurveySectionType.CHECKBOX) {
            const min = Number(setup.limit_options_min);
            const max = Number(setup.limit_options_max);
            const total = (list || []).length;
            ret = lang('多选');
            if (min && max) {
                if (min === max) {
                    ret = lang('多选 {$0{0=个,1=个}}选项', min);
                } else if (min === 1) {
                    ret = lang('多选 至多{$0{0=个,1=个}}选项', max);
                } else if (max === total) {
                    ret = lang('多选 至少{$0{0=个,1=个}}选项', min);
                } else {
                    ret = lang('多选 {$0}-{$1}个选项', min, max);
                }
            }
            retTitle.push(ret);
        } else if (type === ESurveySectionType.RADIO) {
            ret = lang('单选');
            retTitle.push(ret);
        } else if (type === ESurveySectionType.TEXTAREA) {
            ret = lang('开放式');
            retTitle.push(ret);
        } else if (type === ESurveySectionType.NUMBER) {
            ret = lang('数值型');
            retTitle.push(ret);
        }

        retTitle.push(lang('{$0{0=人,1=人}}提交', userCount));

        if (retTitle.length) {
            ret = commonLang('（') + retTitle.join(commonLang('，')) + commonLang('）');
        }

        return ret;
    };

    public render() {
        return this.renderSectionHeader();
    }
}
